import momentLocaleLoader from './momentLocaleLoader';

export default momentLocaleLoader;
